import { AxiosInstance } from "axios"
import { DateTime } from "luxon"
import { MessageTagValue } from "../../../../modules/merchant/admin/messages/messagesTypes"

export enum NotificationQuery {
    NOTIFICATIONS_LIST = "notifications-list",
}

export type FetchNotificationsParams = Readonly<{
    fromDatetime?: DateTime
}>

export type FetchNotificationsResponse = Readonly<{
    notifications: Array<{
        id: number
        tag: MessageTagValue
        subject: string
        message: string
        created: string
        notificationType: string
        uid: string
    }>
}>

export async function fetchNotifications(
    { fromDatetime }: FetchNotificationsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchNotificationsResponse> {
    const url = "/client/notifications"

    const { data } = await axios.post(
        url,
        { fromDatetime: fromDatetime || DateTime.now() },
        {
            signal,
        },
    )

    return data
}

